export default __webpack_public_path__ + "static/helping-break-down-barriers-4c5acb1f6cd4dae7b295274b3a4eca14.jpg";